import React from 'react';


const ContactInfoToggle = (props) => {

  if (props.showContactInfo === false) {
    return (
      <div>
        <p onClick={props.clicked}>click to show contact info</p>
      </div>
    )
  }

  return (
    <div>
      <p onClick={props.clicked}>click to hide contact info</p>
    </div>
  );
}

export default ContactInfoToggle;



// WEBPACK FOOTER //
// ./src/containers/Contacts/ContactInfoToggle.js